import React, {PureComponent} from 'react';
import { Flag } from 'flag';

import CropSubMenu from 'components/AdjustmentMenu/CropSubMenu';
import FlipSubMenu from 'components/AdjustmentMenu/FlipSubMenu';
import RotateSubMenu from 'components/AdjustmentMenu/RotateSubMenu';
import FiltersSubMenu from 'components/AdjustmentMenu/FiltersSubMenu';
import AdjustSubMenu from 'components/AdjustmentMenu/AdjustSubMenu';

import AdjustSVG from 'assets/icons/adjust.svg';
import CropSVG from 'assets/icons/crop.svg';
import FiltersSVG from 'assets/icons/filters.svg';
import FlipSVG from 'assets/icons/flip-h.svg';
import RotateSVG from 'assets/icons/rotate-ccw.svg';

import {applyFilters} from 'utils';

import styles from './styles';

const DEFAULT_MENU_ITEM = '';

export default class AdjustmentMenu extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      menuItem: DEFAULT_MENU_ITEM,
      selectedFilter: 'Normal',
      filter: {}
    };
  }

  onSelectItem = (item) => () => {
    const {menuItem} = this.state;

    if (item === menuItem) {
      // if we want to toggle off the adjustment menu items, here's the place
      this.setState({
        menuItem: DEFAULT_MENU_ITEM
      });
    } else {
      this.setState({
        menuItem: item
      });
    }
  };

  // When the filter is changed, override the filter prop
  onChangeFilter = (selectedFilter, filter) => this.setState({ selectedFilter, filter });

  // When the filter is adjusted, change the one property and leave the rest
  onChangeAdjustment = (property, value) => this.setState({
    filter: {
      ...this.state.filter,
      [property]: value
    }
  });

  // Draw the filters when the component state changes
  updateFilter() {
    const {filter} = this.state;
    const {cropper, filterCanvas, filterImage, imageWidth, imageHeight, onFilterDrawn} = this.props;

    // Don't try to draw filters when WebGL is disabled
    if (!filterCanvas) {
      return;
    }

    // Make the texture
    const texture = filterCanvas.texture(filterImage);

    // Add the base image
    filterCanvas.draw(texture);

    const filteredCanvas = applyFilters(filterCanvas, filter);

    // Finally, draw the image
    filteredCanvas.update();

    const fourthCanvas = document.createElement('canvas');
    fourthCanvas.width = imageWidth;
    fourthCanvas.height = imageHeight;
    fourthCanvas.getContext('2d').drawImage(filteredCanvas, 0, 0, fourthCanvas.width, fourthCanvas.height);

    // Set the image in ImageCrop and draw it
    cropper.setImage(fourthCanvas).draw();

    // Cleanup
    texture.destroy();

    // Notify the parent that we've drawn a filter
    onFilterDrawn(filter);
  }

  // Draw the cropping canvas when the component state changes
  componentDidUpdate(prevProps, prevState) {
    const {cropper, filterImage} = this.props;
    const {menuItem, filter} = this.state;

    if (menuItem === 'crop') {
      cropper.enable('selection');
    } else {
      cropper.disable('selection');
    }

    if (prevState.filter !== filter || prevProps.filterImage !== filterImage) {
      this.updateFilter();
    }
  }

  renderActions() {
    const {menuItem} = this.state;

    const actions = [{
      Icon: CropSVG,
      itemName: 'crop',
      label: 'Crop'
    }, {
      Icon: FlipSVG,
      itemName: 'flip',
      label: 'Flip'
    }, {
      Icon: RotateSVG,
      itemName: 'rotate',
      label: 'Rotate'
    }, {
      Icon: FiltersSVG,
      itemName: 'filters',
      label: 'Filters'
    }, {
      Icon: AdjustSVG,
      itemName: 'adjust',
      label: 'Adjust'
    }];

    return actions.map(({ Icon, itemName, label }) => (
      <Flag name={`adjustments.${itemName}`} key={`adjust-${itemName}`}>
        <button
          className={`${styles.adjustmentItem} ${menuItem === itemName ? 'selected' : ''}`}
          onClick={this.onSelectItem(itemName)}
        >
          <Icon className={styles.icon} />
          {label}
        </button>
      </Flag>
    ));
  }

  renderSubMenu() {
    const {cropper, image, thumbnailImage} = this.props;
    const {menuItem} = this.state;

    switch (menuItem) {
      case 'crop':
        return <CropSubMenu image={image} cropper={cropper} />;
      case 'flip':
        return <FlipSubMenu cropper={cropper} />;
      case 'rotate':
        return <RotateSubMenu cropper={cropper} />;
      case 'filters':
        return (
          <Flag
            name="adjustments.filters"
            component={FiltersSubMenu}
            thumbnailImage={thumbnailImage}
            selectedFilter={this.state.selectedFilter}
            onChange={this.onChangeFilter}
          />
        );
      case 'adjust':
        return (
          <Flag
            name="adjustments.adjust"
            component={AdjustSubMenu}
            onChange={this.onChangeAdjustment}
            {...this.state.filter}
          />
        );
      default:
        return null;
    }
  }

  render() {
    const {menuItem} = this.state;

    return (
      <div className={`${styles.adjustmentMenu} ${menuItem}`}>
        {this.renderActions()}
        {this.renderSubMenu()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdjustmentMenu/index.jsx